import React, {Component} from "react";

export default class SocialBanner extends Component {

    render() {
        const {instagram} = this.props;
        return (
            <a className="ps-section__left bg--cover-2" href={instagram} data-background="/img/instagram-section.jpg">
                <div className="ps-section__instagram">

                </div>
            </a>
        );
    }
}

